// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getQuoteDetails from "@bg/App/Handlers/CustomQuote/GetCustomQuote";
import { uploadLogo as uploadLogoApi, UploadLogoParams } from "@bg/App/Services/CustomQuoteService";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface UploadLogoHandlerParameter {
    formData: any;
    customQuoteId: string;
    onSuccess?: (error: string) => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<UploadLogoHandlerParameter, UploadLogoParams, ServiceResult<any>>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        formData: props.parameter.formData,
        customQuoteId: props.parameter.customQuoteId,
    };
};

export const UploadLogoCall: HandlerType = async props => {
    props.apiResult = await uploadLogoApi(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result!);
    }
};

export const chain = [PopulateApiParameter, UploadLogoCall, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const uploadLogo = createHandlerChainRunner(chain, "UploadLogo");
export default uploadLogo;
